/**
 * Firestore layout (docs/architecture.md):
 * - Company data is organization-scoped under `organizations/{orgId}/…`
 * - Platform catalogs: `lenders`, `installmentOptions`
 * - Public token map: `publicCheckoutTokens/{tokenHash}`
 * - Personal data: `users/{uid}`
 */

export const COLLECTION_USERS = 'users';
export const COLLECTION_ORGANIZATIONS = 'organizations';
export const COLLECTION_LENDERS = 'lenders';
export const COLLECTION_INSTALLMENT_OPTIONS = 'installmentOptions';
export const COLLECTION_PUBLIC_CHECKOUT_TOKENS = 'publicCheckoutTokens';

export const SUBCOLLECTION_MEMBERS = 'members';
export const SUBCOLLECTION_INVITATIONS = 'invitations';
export const SUBCOLLECTION_CUSTOMERS = 'customers';
export const SUBCOLLECTION_COMMERCIAL_DOCUMENTS = 'commercialDocuments';
export const SUBCOLLECTION_DOCUMENT_PROCESSING_JOBS = 'documentProcessingJobs';
export const SUBCOLLECTION_FILES = 'files';
export const SUBCOLLECTION_CHECKOUT_CONFIGURATIONS = 'checkoutConfigurations';
export const SUBCOLLECTION_COMPANY_BRANDING = 'companyBranding';
export const SUBCOLLECTION_FINANCING_CASES = 'financingCases';
export const SUBCOLLECTION_FINANCING_APPLICATIONS = 'financingApplications';
export const SUBCOLLECTION_CONSENT_RECORDS = 'consentRecords';
export const SUBCOLLECTION_AUDIT_EVENTS = 'auditEvents';
export const SUBCOLLECTION_INTERNAL_NOTES = 'internalNotes';

export function orgPath(orgId: string): string {
  return `${COLLECTION_ORGANIZATIONS}/${orgId}`;
}

export function orgSubcollectionPath(orgId: string, subcollection: string): string {
  return `${orgPath(orgId)}/${subcollection}`;
}

export function orgMemberPath(orgId: string, uid: string): string {
  return `${orgSubcollectionPath(orgId, SUBCOLLECTION_MEMBERS)}/${uid}`;
}

export function commercialDocumentStoragePath(
  orgId: string,
  documentId: string,
  fileName: string
): string {
  return `companies/${orgId}/commercial-documents/${documentId}/${fileName}`;
}

export function brandingStoragePath(orgId: string, assetId: string, fileName: string): string {
  return `companies/${orgId}/branding/${assetId}/${fileName}`;
}

const SEP = '__';

/**
 * User-scoped document ID = `{userId}__{itemId}`.
 * Applies to personal data only.
 */
export function ownedItemDocId(userId: string, itemId: string): string {
  return `${userId}${SEP}${itemId}`;
}
